import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, Teleport as _Teleport, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-d9b74f76")

_pushScopeId("data-v-d9b74f76")
const _hoisted_1 = { class: "card" }
const _hoisted_2 = { class: "row card-p list-search-area border-bottom pb-5 mb-5 align-items-end" }
const _hoisted_3 = { class: "col-md-4 col-xl-3 mb-4 mb-md-0 inactive-coffee-filter" }
const _hoisted_4 = { class: "d-flex align-items-center fs-6 fw-bold mb-2 text-nowrap" }
const _hoisted_5 = { class: "col-md-4 col-xl-3 mb-4 mb-md-0 d-flex align-items-center rental-agreement-filter" }
const _hoisted_6 = { class: "inactive-coffee-table" }
const _hoisted_7 = { class: "symbol symbol-45px custom" }
const _hoisted_8 = { key: 0 }
const _hoisted_9 = { key: 1 }
const _hoisted_10 = {
  key: 0,
  class: "badge badge-light-primary"
}
const _hoisted_11 = {
  key: 1,
  class: "badge badge-light-dark"
}
const _hoisted_12 = {
  key: 0,
  class: "badge badge-light-primary"
}
const _hoisted_13 = {
  key: 1,
  class: "badge badge-light-danger"
}
const _hoisted_14 = /*#__PURE__*/_createVNode("i", { class: "fas fa-ellipsis-h" }, null, -1)
const _hoisted_15 = {
  key: 0,
  class: "menu-item"
}
const _hoisted_16 = /*#__PURE__*/_createVNode("span", { class: "svg-icon svg-icon-3" }, [
  /*#__PURE__*/_createVNode("i", { class: "fas fa-clipboard-list" })
], -1)
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_InnerLoader = _resolveComponent("InnerLoader")!
  const _component_Select = _resolveComponent("Select")!
  const _component_el_checkbox = _resolveComponent("el-checkbox")!
  const _component_AdvanceSearch = _resolveComponent("AdvanceSearch")!
  const _component_Table = _resolveComponent("Table")!

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode(_component_InnerLoader, { loading: _ctx.loader }, null, 8, ["loading"]),
    _createVNode("div", _hoisted_2, [
      _createVNode("div", _hoisted_3, [
        _createVNode("label", _hoisted_4, [
          _createVNode("span", null, _toDisplayString(_ctx.$t('message.MONTHS_WITHOUT_COFFEE_PURCHASE')), 1)
        ]),
        _createVNode(_component_Select, {
          name: "months_without_purchase",
          target: "months_without_purchase",
          months_without_purchase: _ctx.selectedMonths,
          "onUpdate:months_without_purchase": _cache[1] || (_cache[1] = ($event: any) => (_ctx.selectedMonths = $event)),
          selectData: _ctx.monthsOptions,
          filterable: false,
          clearable: false,
          placeholder: _ctx.$t('message.SELECT'),
          value: _ctx.selectedMonths
        }, null, 8, ["months_without_purchase", "selectData", "placeholder", "value"])
      ]),
      _createVNode("div", _hoisted_5, [
        _createVNode(_component_el_checkbox, {
          modelValue: _ctx.rentalAgreementOnly,
          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.rentalAgreementOnly = $event)),
          label: _ctx.$t('message.RENTAL_AGREEMENT_CLIENTS_ONLY')
        }, null, 8, ["modelValue", "label"])
      ])
    ]),
    _createVNode(_component_AdvanceSearch, {
      filter: true,
      filterOption: _ctx.filterOption,
      status: _ctx.statusList,
      customer_group: _ctx.customerGroupList,
      onExportFile: _ctx.exportFile,
      onSearch: _ctx.searchHandler,
      onReloadListing: _cache[3] || (_cache[3] = ($event: any) => (_ctx.reloadReportListing(1, true)))
    }, null, 8, ["filterOption", "status", "customer_group", "onExportFile", "onSearch"]),
    _createVNode("div", _hoisted_6, [
      _createVNode(_component_Table, {
        loading: _ctx.loader,
        columns: _ctx.columns,
        rows: _ctx.reports,
        pagination: _ctx.pagination,
        padding: 2,
        onHandleCurrentChange: _ctx.handleCurrentChange,
        onSorting: _ctx.searchHandler
      }, {
        "cell-avatar": _withId(({ row: item }) => [
          _createVNode("div", _hoisted_7, [
            _createVNode("div", {
              class: "navatar",
              style: 'background-color:' + _ctx.generateAvatar(item?.user?.name)?.color
            }, [
              _createVNode("span", null, _toDisplayString(_ctx.generateAvatar(item?.user?.name)?.name), 1)
            ], 4)
          ])
        ]),
        "cell-name": _withId(({ row: item }) => [
          _createTextVNode(_toDisplayString(item?.user?.name), 1)
        ]),
        "cell-email": _withId(({ row: item }) => [
          _createTextVNode(_toDisplayString(item?.user?.email), 1)
        ]),
        "cell-economic_number": _withId(({ row: item }) => [
          _createTextVNode(_toDisplayString(item?.economic_number || 'N/A'), 1)
        ]),
        "cell-customer_group": _withId(({ row: item }) => [
          _createTextVNode(_toDisplayString(item?.customer_group?.name || 'N/A'), 1)
        ]),
        "cell-last_coffee_order_date": _withId(({ row: item }) => [
          _createTextVNode(_toDisplayString(item?.last_coffee_order_date || _ctx.$t('message.NO_DATA_FOUND')), 1)
        ]),
        "cell-days_since_last_coffee_order": _withId(({ row: item }) => [
          (item?.days_since_last_coffee_order != null)
            ? (_openBlock(), _createBlock("span", _hoisted_8, _toDisplayString(item.days_since_last_coffee_order), 1))
            : (_openBlock(), _createBlock("span", _hoisted_9, "N/A"))
        ]),
        "cell-in_cup_agreement": _withId(({ row: item }) => [
          (item?.in_cup_agreement == 1)
            ? (_openBlock(), _createBlock("span", _hoisted_10, _toDisplayString(_ctx.$t('message.YES')), 1))
            : (_openBlock(), _createBlock("span", _hoisted_11, _toDisplayString(_ctx.$t('message.NO')), 1))
        ]),
        "cell-status": _withId(({ row: item }) => [
          (item?.user?.status == 1)
            ? (_openBlock(), _createBlock("span", _hoisted_12, _toDisplayString(_ctx.$t('message.ACTIVE')), 1))
            : (_openBlock(), _createBlock("span", _hoisted_13, _toDisplayString(_ctx.$t('message.INACTIVE')), 1))
        ]),
        "cell-actions": _withId(({ row: item }) => [
          _createVNode("button", {
            class: "action-btn",
            type: "button",
            onClick: ($event: any) => (_ctx.dropdownHandler(_ctx.activeIndex, item?.id, $event))
          }, [
            _hoisted_14
          ], 8, ["onClick"])
        ]),
        _: 1
      }, 8, ["loading", "columns", "rows", "pagination", "onHandleCurrentChange", "onSorting"])
    ]),
    (_openBlock(), _createBlock(_Teleport, { to: "body" }, [
      (_ctx.activeReport)
        ? (_openBlock(), _createBlock("div", {
            key: 0,
            ref: "dropdownMenuRef",
            class: ["dropdown-menu dropdown-menu-end action-dropdown inactive-coffee-action-menu", { 'is-dark': _ctx.dropdownIsDark }],
            style: _ctx.dropdownMenuStyle
          }, [
            _createVNode("div", {
              class: "menu-item-wrapper",
              onClick: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.closeDropdown && _ctx.closeDropdown(...args)))
            }, [
              (_ctx.$can('view_customer'))
                ? (_openBlock(), _createBlock("div", _hoisted_15, [
                    _createVNode("a", {
                      onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.handleView(_ctx.activeReport))),
                      class: "menu-link me-1"
                    }, [
                      _hoisted_16,
                      _createTextVNode(" " + _toDisplayString(_ctx.$t('message.VIEW')), 1)
                    ])
                  ]))
                : _createCommentVNode("", true)
            ])
          ], 6))
        : _createCommentVNode("", true)
    ]))
  ]))
})